import type { UserResponse, UserRole } from "../api/types";
import { useAuth } from "./useAuth";

/**
 * Convenience hook — returns the current user (or null if signed-out).
 * Equivalent to `useAuth().user` but cleaner at call sites.
 */
export function useUser(): UserResponse | null {
  return useAuth().user;
}

/**
 * Returns true if the current user has any of the supplied roles.
 * Returns false when signed-out.
 *
 * Used by RequireRole (Stage 6) and AppShell nav-item visibility.
 */
export function useHasRole(...roles: UserRole[]): boolean {
  const user = useUser();
  if (!user) return false;
  return roles.includes(user.role);
}
